"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _types = require("./types");
Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _types[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _types[key];
    }
  });
});
var _acceptMarketingSubscription = require("./acceptMarketingSubscription");
Object.keys(_acceptMarketingSubscription).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _acceptMarketingSubscription[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _acceptMarketingSubscription[key];
    }
  });
});
var _acceptLicence = require("./acceptLicence");
Object.keys(_acceptLicence).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _acceptLicence[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _acceptLicence[key];
    }
  });
});
var _applyAgreement = require("./applyAgreement");
Object.keys(_applyAgreement).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _applyAgreement[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _applyAgreement[key];
    }
  });
});